import "@babel/polyfill";
import Vue from "vue";

import App from "./App.vue";
import router from "./router";
//import VueProgressBar from "vue-progressbar";
import axios from "axios";
import VueAxios from "vue-axios";
import jwt_decode from "jwt-decode";
import VueFilterDateFormat from "vue-filter-date-format";
import store from "./store/index";


//TODO 用不了了 有一段时间
import VueAnalytics from 'vue-analytics'
Vue.use(VueAnalytics, {
  id: process.env.VUE_APP_GA_TRACKING_ID,
  router
});


Vue.config.productionTip = false;

// Vue.prototype.$currentCompany =
//   localStorage.getItem("currentCompanyId") === null ||
//   localStorage.getItem("currentCompanyName") === null
//     ? null
//     : {
//       id: parseInt(localStorage.getItem("currentCompanyId")),
//       name: localStorage.getItem("currentCompanyName")
//     };


// const options = {
//   color: "#2196f3",//
//   failedColor: "#874b4b",
//   thickness: "5px",
//   transition: {
//     speed: "0.1s",
//     opacity: "0.5s",
//     termination: 400
//   },
//   autoRevert: true,
//   location: "top",
//   inverse: false
// };
//
// Vue.use(VueProgressBar, options);
Vue.use(VueAxios, axios);


Vue.use(VueFilterDateFormat);

Vue.mixin({
  computed: {
    currentUser() {
      let accessToken = localStorage.getItem("accessToken");
      if (accessToken == null) {
        return null;
      } else {
        let decoded = jwt_decode(accessToken);
        //console.log(decoded);
        return {username: decoded.sub, role: decoded.role,firmId:decoded.firm,companyId:decoded.company};
      }
    },
    recaptchaSitekey() {
      return '6Lc2_K0UAAAAAPbP53-fOmtGoERoIJA6NCyakpI9';
    }
  },
  methods: {
    // setCurrentCompany(value) {
    //   Vue.prototype.$currentCompany = value;
    //   if (value == null) {
    //     localStorage.removeItem("currentCompanyId");
    //     localStorage.removeItem("currentCompanyName");
    //   } else {
    //     localStorage.setItem("currentCompanyId", value.id);
    //     localStorage.setItem("currentCompanyName", value.name);
    //   }
    // },
    // saveAs(obj, fileName) {
    //   if ('msSaveOrOpenBlob' in navigator) {
    //     // Microsoft Edge and Microsoft Internet Explorer 10-11
    //     window.navigator.msSaveOrOpenBlob(obj, fileName);
    //   } else {
    //     // standard code for Google Chrome, Mozilla Firefox etc
    //     var tmpa = document.createElement("a");
    //     tmpa.download = fileName || "download";
    //     tmpa.href = URL.createObjectURL(obj); //绑定a标签
    //     tmpa.click(); //模拟点击实现下载
    //     //延时释放
    //     setTimeout(function () {
    //       URL.revokeObjectURL(obj); //用URL.revokeObjectURL()来释放这个object URL
    //     }, 100);
    //   }
    // }
  }
});

export default new Vue({
  store,
  router,
  render: h => h(App)
}).$mount("#app");
